import { AppError, EipError } from 'src/redux/types';
export const formatErrorMessage = checkoutError => {
  switch (checkoutError) {
    case EipError.USER_REJECTED_REQUEST:
      return 'Transaction has been canceled';

    case AppError.INSUFFICIENT_BALANCE:
      return 'Insufficient balance to stake';

    case AppError.STAKING_POOL_FULLED:
      return 'You have exceeded the pool limit';

    default:
      return `Something went wrong.`;
  }
};